(() => {
 // Redirect only when an empty drawer is opened or its last item is removed.
 // An empty cart on ordinary page load must never redirect browsing visitors.
 function watchEmptyDrawer() {
  const drawer = document.querySelector('cart-drawer.moveo-cart');
  if (!drawer) return;
  let redirecting = false;
  const check = () => {
   if (redirecting || !drawer.classList.contains('active') || !drawer.classList.contains('is-empty')) return;
   const root = window.Shopify?.routes?.root || '/';
   const target = root + 'products/motionpro';
   if (location.pathname.replace(/\/$/,'') === target.replace(/\/$/,'')) {
    drawer.close();
    document.getElementById('mpbWrap')?.scrollIntoView({block:'center',behavior:'auto'});
    return;
   }
   redirecting = true;
   location.assign(target);
  };
  new MutationObserver(check).observe(drawer, {attributes:true,attributeFilter:['class']});
  check();
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',watchEmptyDrawer,{once:true});
 else watchEmptyDrawer();
 let pending = false;
 document.addEventListener('change', (event) => {
  const select = event.target.closest('select[data-extra-variant]');
  if (!select) return;
  const price = select.selectedOptions[0]?.dataset.price;
  const row = select.closest('[data-moveo-extra]');
  if (price) row.querySelector('[data-extra-price]').textContent = price;
  const compare = select.selectedOptions[0]?.dataset.compare || '';
  const compareElement = row.querySelector('[data-extra-compare]');
  if (compareElement) {
   compareElement.querySelector('bdi').textContent = compare;
   compareElement.hidden = !compare;
  }
 });
 document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-extra-add]');
  if (!button || pending) return;
  const row = button.closest('[data-moveo-extra]');
  const variant = row.querySelector('[data-extra-variant]');
  const status = row.querySelector('.moveo-extra-status');
  if (!variant.value) { status.textContent = 'בחרו אפשרות לפני ההוספה'; variant.focus(); return; }
  const drawer = button.closest('cart-drawer');
  const root = window.Shopify?.routes?.root || '/';
  pending = true;
  drawer.setAttribute('aria-busy','true');
  const controls = [...drawer.querySelectorAll('button,input,select')].filter(el => !el.disabled && !el.classList.contains('drawer__close'));
  controls.forEach(el => el.disabled = true);
  let added = false;
  try {
   status.textContent = 'מוסיף להזמנה…';
   const response = await fetch(root + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.value,quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname}) });
   const result = await response.json();
   if (!response.ok) throw new Error(result.description || 'לא ניתן להוסיף את המוצר כרגע');
   added = true;
   if (!result.sections?.['cart-drawer'] || !result.sections?.['cart-icon-bubble']) { location.assign(root+'cart'); return; }
   drawer.renderContents(result);
   drawer.querySelector('.drawer__close')?.focus();
   document.dispatchEvent(new CustomEvent('cart:updated'));
  } catch(error) {
   if (added) { location.assign(root+'cart'); return; }
   status.textContent = error.message || 'שגיאה בהוספה. בדקו את העגלה לפני ניסיון נוסף.';
  } finally {
   pending = false;
   drawer.removeAttribute('aria-busy');
   controls.forEach(el => { if (el.isConnected) el.disabled = false; });
  }
 });
})();
